export default __webpack_public_path__ + "static/media/shoulder_press_start.5ab4efc7.svg";